import React from 'react';
import { BusinessPartnerRole } from '../../types';
import { BusinessPartnerSelector } from './BusinessPartnerSelector';

interface BusinessPartnerSelection {
  partnerId: string;
  locationId?: string;
}

interface BusinessPartnerFormProps {
  billing?: BusinessPartnerSelection;
  onBillingChange: (selection: BusinessPartnerSelection | null) => void;
  disabled?: boolean;
  className?: string;
  // 編集モード時の現在の取引先ID
  currentBillingPartnerId?: string;
}

export const BusinessPartnerForm: React.FC<BusinessPartnerFormProps> = ({
  billing,
  onBillingChange,
  disabled = false,
  className = '',
  currentBillingPartnerId,
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      <div className='grid grid-cols-1 gap-6'>
        {/* 請求先選択 */}
        <div className='max-w-md'>
          <BusinessPartnerSelector
            value={billing}
            onChange={onBillingChange}
            role={BusinessPartnerRole.BILLING}
            label='請求先'
            placeholder='請求先を選択してください'
            required={true}
            disabled={disabled}
            allowCustomInput={true}
            currentPartnerId={currentBillingPartnerId}
          />
        </div>
      </div>
    </div>
  );
};
